import { render, staticRenderFns } from "./CreateCoverAndIntroduction.vue?vue&type=template&id=84283d7c&scoped=true&"
import script from "./CreateCoverAndIntroduction.vue?vue&type=script&lang=js&"
export * from "./CreateCoverAndIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./CreateCoverAndIntroduction.vue?vue&type=style&index=0&id=84283d7c&prod&scoped=true&lang=css&"
import style1 from "./CreateCoverAndIntroduction.vue?vue&type=style&index=1&id=84283d7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84283d7c",
  null
  
)

export default component.exports